import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSubscriptionsEpic } from './_epics/loadSubscriptions.epic';
import { reloadSubscriptionsEpic } from './_epics/reloadSubscriptions.epic';
import { updateSubscriptionEpic } from './_epics/updateSubscription.epic';
import { addEmailToSubscriptionEpic } from './_epics/addEmailToSubscription.epic';
import { addEmailEpic } from './_epics/addEmail.epic';
import { deleteEmailEpic } from './_epics/deleteEmail.epic';

export const alertSubscriptionEpic = safeCombineEpics(
  loadSubscriptionsEpic,
  reloadSubscriptionsEpic,
  updateSubscriptionEpic,
  addEmailToSubscriptionEpic,
  addEmailEpic,
  deleteEmailEpic,
);
